import { Pipe, PipeTransform } from '@angular/core';
import { ReportStatus } from './requested-reports.component';

@Pipe({
  name: 'statusToText',
})
export class StatusToTextPipe implements PipeTransform {
  transform(value: ReportStatus): string {
    switch (value) {
      case ReportStatus.READY:
        return 'Ready';
      case ReportStatus.PAYMENT_ERROR:
        return 'Payment error';
      case ReportStatus.AUTOMATION_ERROR:
        return 'Error';
      default:
        return 'In progress';
    }
  }
}
